export default {
    attack: "ataque",
    specialAttack: "ataque especial",
    defense: "defesa",
    specialDefense: "defesa especial",
    speed: "velocidade",
    accuracy: "precisão",
    evasion: "evasão"
};